/**
 * § 303 — one number formatter for every count the design system prints.
 *
 * `Pagination` printed "Showing 1–50 of 12345", `Badge` "1240", `SelectionBar` the
 * same through Badge: raw digits, in a product whose catalogues run to five and six
 * figures. `Intl.NumberFormat` with the runtime locale gives the thousands separator
 * the reader expects ("12,345" here, "12.345" in Berlin) and costs nothing to keep
 * honest — there is exactly one call site to retune.
 *
 * Anything that is not a finite number comes back untouched, so a caller can hand it
 * whatever it was already rendering.
 */
const formatter: Intl.NumberFormat | undefined =
  typeof Intl !== 'undefined' && typeof Intl.NumberFormat === 'function' ? new Intl.NumberFormat() : undefined;

export const formatCount = (value: number | string): string => {
  const n = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(n)) return String(value);
  return formatter ? formatter.format(n) : String(n);
};
